import { DateTime } from 'luxon';
import { z } from 'zod';

import { LAST_4_SSN_LENGTH, SSN_LENGTH } from '@clearverify/constants';

import { IdentitySearchFormFields } from './constants';
import type { IdentitySearchFormValues } from './types';

const optionalDigits = (length: number, message: string) =>
  z
    .string()
    .nullish()
    .refine(value => {
      if (value == null || value === '') return true;
      const digits = value.replace(/\D/g, '');
      return digits.length === 0 || digits.length === length;
    }, message);

const optionalString = z.string().nullish();

const optionalIsoDate = z
  .string()
  .nullish()
  .refine(value => !value || DateTime.fromISO(value).isValid, 'Invalid date');

export const identitySearchFormValidationSchema = (
  z.object({
    [IdentitySearchFormFields.ssn]: optionalDigits(SSN_LENGTH, `SSN must be ${SSN_LENGTH} digits`),
    [IdentitySearchFormFields.last4Ssn]: optionalDigits(
      LAST_4_SSN_LENGTH,
      `Last 4 of SSN must be ${LAST_4_SSN_LENGTH} digits`,
    ),
    [IdentitySearchFormFields.firstName]: optionalString,
    [IdentitySearchFormFields.lastName]: optionalString,
    [IdentitySearchFormFields.birthDate]: optionalIsoDate,
  }) satisfies z.ZodType<IdentitySearchFormValues>
).superRefine((values, ctx) => {
  const hasAny = Object.values(values).some(
    value => value != null && String(value).trim().length > 0,
  );
  if (!hasAny) {
    ctx.addIssue({
      code: 'custom',
      message: 'Fill at least one field to search.',
      // Attach to the form root so it shows once, not pinned to the SSN field.
      path: [],
    });
  }
});
